export class User {
    constructor(
        public id: string,
        public avatar_url: string,
        public name: string,
        public address: string,
        public phone: string,
        public email: string,
        public password: string,
        public total_time: number,
        public time_earn: number,
        public time_use: number,
        public financial_code: any,
        public is_admin: boolean,
        public is_confirm: boolean,
        public is_charity: boolean,
        public total_rate: number,
        public account_type: string,
        public specialty_description: string,
        public certifications_description: string,
        public is_super_admin?: boolean,
        public task_completed?: number
    ) { }
}
